var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislikeWithCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9806 5.38062 18.6194 0.0193593 12 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39995 13.6H7.59995C7.37904 13.6 7.19995 13.4209 7.19995 13.2V8.39998C7.19995 8.17906 7.37904 7.99998 7.59995 7.99998H8.79995V13.2C8.79995 13.4209 8.62087 13.6 8.39995 13.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9529 13.9468C15.8386 13.9821 15.7197 14 15.6001 14H13.2001V15.2C13.2001 16.7296 12.1645 17.1768 11.6169 17.2C11.5082 17.2038 11.4024 17.1639 11.3233 17.0892C11.2445 17.0137 11.2 16.9092 11.2001 16.8V14.9448L9.6001 13.0248V8H14.4921C15.02 7.99759 15.4868 8.34208 15.6401 8.84721L16.7477 12.4472C16.8412 12.7515 16.81 13.0804 16.6609 13.3616C16.5119 13.6429 16.2572 13.8534 15.9529 13.9468Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeWithCircle);
export default __webpack_public_path__ + "static/media/dislikeWithCircle.c2221fd4.svg";
export { ForwardRef as ReactComponent };